<script setup>
import {computed} from 'vue'
import PageContentOrphanedItem from "./PageContentOrphanedItem.vue"
import {usePageContentDataStore} from '@/stores/pageContentData'

const props = defineProps({
    pageId: Number,
    contentAreas: Array
})

const pageContentDataStore = usePageContentDataStore()

// Computed properties
const items = computed(() => {
    if (props.contentAreas) {
        return pageContentDataStore.items.filter((o) => {
            return (
                o.pageId === props.pageId &&
                props.contentAreas.indexOf(o.contentArea) === -1
            )
        })
    }
    return []
})

const lastContentArea = computed(() => {
    if (!props.contentAreas || !props.contentAreas.length) return null
    return props.contentAreas[props.contentAreas.length - 1]
})
</script>

<template>
    <section v-if="items?.length">
        <div class="ms-2">
            <label class="form-label mb-1 small">Unassigned content</label>
            <p class="form-text mt-0 mb-2" style="font-size: 13px">
                Content not assigned to a page template's content area will not be displayed.
            </p>
        </div>

        <div class="list-group">
            <PageContentOrphanedItem v-for="item in items" :key="item.id" :page-content-data-item="item"
                                     :last-content-area="lastContentArea" class="list-group-item"/>
        </div>
    </section>
</template>